import { type NumberSchema, number as numberSchema } from "yup";

export const number = (): NumberSchema => numberSchema().transform((value) => (Number.isNaN(value) ? undefined : value));
